import React from 'react'

import { Redirect, Route } from 'react-router-dom'

import { Button, Card, Flex, Link } from '@driftt/dds'
import { ChartCard } from '@driftt/dds.reports'

import FastlaneAlert from 'components/FastlaneAlert'
import MeetingLineChart from 'components/meeting/MeetingLineChart'
import MeetingOutcomesChart from 'components/meeting/MeetingOutcomesChart'
import MeetingsTopPerformersChart from 'components/meeting/MeetingsTopPerformersChart'
import UnqualifiedMeetingRequestsChart from 'components/meeting/UnqualifiedMeetingRequestsChart'
import WhoBookedMeetingsChart from 'components/meeting/WhoBookedMeetingsChart'
import ReportsCompoundFilterBar from 'components/ReportsCompoundFilter'
import SectionHeader from 'components/SectionHeader'
import { MEETINGS } from 'constants/sections/meetings'
import useAvailableFilters from 'hooks/useAvailableFilters'
import { ReportPage } from 'types/pages'
import { hasGates, userHasOrgConversationReports } from 'utils/access'

import './style.css'

const meetingsFilters = {
  reportType: ReportPage.Meeting,
  showAdvancedFilters: true,
}

const MeetingsByDayContent = () => {
  const availableFilterableEntities = useAvailableFilters({
    ...meetingsFilters,
  })

  return (
    <Flex
      direction="column"
      gap={3}
      fullWidth
      css={{
        padding: '$2 $2 $3',
      }}
    >
      <ReportsCompoundFilterBar
        reportAmounts={3}
        availableFilterableEntities={availableFilterableEntities}
        reportType={ReportPage.Meeting}
      />
      <Flex.Item alignSelf="stretch">
        <Card>
          <MeetingLineChart
            title="Meetings booked"
            tooltip="This is a cumulative view of all\nmeetings booked with Drift
          (via\nplaybook and chat conversations,\nmeeting links, Drift profiles etc)"
            tooltipFlow="up"
            cumulative
            metric="meetingsBookedByDate"
          />
        </Card>
      </Flex.Item>
      {userHasOrgConversationReports() && (
        <Flex.Item alignSelf="stretch">
          <MeetingsTopPerformersChart />
        </Flex.Item>
      )}
      <Flex.Item alignSelf="stretch">
        <ChartCard>
          <ChartCard.Header
            title="Meeting outcomes"
            subtitle="What are the outcomes of my team's meetings, and what's the breakdown
          by source?"
            action={
              <Link href="/settings2/integrations/detail/salesforce/settings">
                <Button variant="secondary">
                  Manage meeting sync settings
                </Button>
              </Link>
            }
          />
          <ChartCard.Content>
            <MeetingOutcomesChart metric="meetingOutcomes" />
          </ChartCard.Content>
        </ChartCard>
      </Flex.Item>
      <Flex.Item alignSelf="stretch">
        <WhoBookedMeetingsChart metric="meetingsBooked" />
      </Flex.Item>
      {hasGates('has_meeting_pre_qualification') && (
        <Flex.Item alignSelf="stretch">
          <UnqualifiedMeetingRequestsChart metric="unqualifiedMeetingRequests" />
        </Flex.Item>
      )}
    </Flex>
  )
}

const MeetingsReport = () => (
  <div className="meetings-results-layout">
    <SectionHeader {...MEETINGS} />
    <FastlaneAlert />
    <Route path="/meetings">
      <Redirect from="/meetings" to="/meetings/time" exact />
      <Route path="/meetings/time" component={() => <MeetingsByDayContent />} />
    </Route>
  </div>
)

export default MeetingsReport
